<template>
  <div class="w3-container w3-margin-top" style="padding: 0;">

    <div class="w3-col w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando">
      <div class="w3-container" style="padding-left: 0; padding-right: 0">
        <input 
          type="text" 
          v-model="filtro_produtos"
          v-on:keyup="filtrarProdutos()"
          class="w3-input w3-border w3-padding margin-bottom-filtro" 
          placeholder="Filtrar por código ou nome do produto">    
    
        <label>Empresa</label>
        <select 
          @click="mudarPagina(0)"
          v-model="empresa_selecionada_id"
          class="w3-select w3-input w3-border margin-bottom-filtro"
          @change="buscarProdutosEmPromocao()">
          
          <option
            v-for="empresa in empresas_autorizadas" 
            :value="empresa.empresa_id" 
            :key="empresa.empresa_id">
            {{`${empresa.empresa_id} - ${empresa.nome_fantasia}`}}
          </option>
        </select>

        <label>Marca</label>
        <select 
          v-model="filtro_marca"
          @click="filtrarMarca()"
          class="w3-select w3-input w3-border margin-bottom-filtro">
          <option value="">Selecione uma marca</option>
          <option 
            v-for="(marca, index) in marcas"
            :key="index" 
            :value="marca.marca">
            {{marca.marca}}
          </option>
        </select>      
      </div>
    </div>

    <div
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="(
        !processando &&
        !processando_produtos && 
        !produtos_filtrados
      )"
      v-cloak>
      
      <div class="w3-container w3-white">
        <p>Não há produtos a serem exibidos.</p>
      </div>
    </div>

    <div 
      class="wrapper-componente w3-margin-top"
      v-if="!processando">
      
      <div 
        class="w3-container card-item" 
        v-for="(produto, index) in novosProdutosFiltrados" 
        :key="index">
        
        <div class="w3-col w3-text-theme">
          <strong>
            <i class="fas fa-box"></i>
            <span>{{nPadrao(produto.produto_id, 0)}} - </span>
            <span>{{produto.nome_produto}} ({{produto.unidade}})</span>
          </strong>
        </div>
        
        <div class="w3-col">
          <strong>{{produto.marca}}</strong>
        </div>

        <div class="w3-col">
          <label>Preço de venda: </label>
          <strong>{{nPadraoReais(produto.preco_venda)}}</strong>
        </div>
        
        <div class="w3-col">
          <label>Preço promocional: </label>
          <strong>
            <span>{{nPadraoReais(produto.preco_promocional)}} </span>
            <span class="w3-text-green"> ({{nPadraoPercentual(produto.perc_dif_preco_promocional)}})</span>
          </strong>
        </div>
        
        <div class="w3-col s12">
          <label>Período da promoção: </label>
          <strong>
            <span>{{fData(produto.data_inicial)}} até {{fData(produto.data_final)}}</span>
          </strong>
          <span> ({{getDiasRestantes(produto.quantidade_dias_restantes)}})</span>
        </div>

        <div v-if="produto.tem_campanha_promocional" class="w3-col s12">
          <strong>Campanha promocional</strong>
        </div>
      </div>

      <paginacao 
        @pagina="mudarPagina"
        :pagina-atual="paginaAtual" 
        :itens-por-pagina="itensPorPagina"
        :total-resultados="totalResultados" 
        :total-de-paginas="totalDePaginas" />
    </div>

    <div 
      class="w3-col s12 m12 l12 w3-margin-bottom"
      v-if="processando_produtos && !processando">
      
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

  </div>
</template>

<script>
  import store from '@/ambiente/store';
  import Paginacao from '@/components/Paginacao';
  import RSessao from '@/components/Rest/RSessao';
  import REmpresa from '@/components/Rest/REmpresa';
  import Biblioteca from '@/components/Repositorio/Biblioteca';
  import RProdutoBuscarProdutosEmPromocao from '@/components/Rest/RProduto/RProdutoBuscarProdutosEmPromocao';
  
  export default {
    name: 'ProdutosEmPromocao',

    props: ['empresas_id'],
    
    components: {
      Paginacao
    },
    
    data() {
      return {
        produtos_cadastrados_filtrados: [],
        processando: false,
        processando_produtos: false,
        filtro_produtos: '',
        produtos_filtrados: [],
        qtd_total_produtos_promocao: 0,
        mostrar_filtros: false,

        filtro_marca: '',
        empresa_selecionada_id: 0,
        filtro_marca_antiga: '',
        empresa_selecionada_antiga_id: '',
        

        nome_empresa: '',
        empresas: [],
        empresas_autorizadas: [],
        usuario_logado: '',

        paginaAtual: 0,
        itensPorPagina: 10,
        totalResultados: 0,
        totalDePaginas: 0
      }
    },
    methods: {
      mudarPagina(numeroDaPagina) {
        this.paginaAtual = numeroDaPagina;
      },

      filtrarMarca(){
        if (!this.produtos_cadastrados_filtrados){
          this.confirmarQtdProdutoPromocao(0);
          return;
        }

        if (!this.filtro_marca){
          this.produtos_filtrados = JSON.parse(JSON.stringify(this.produtos_cadastrados_filtrados));
          this.confirmarQtdProdutoPromocao(this.produtos_filtrados.length);
          return;
        }

        this.produtos_filtrados = [];
        for (let i = 0; i < this.produtos_cadastrados_filtrados.length; i++) {
          if (this.filtro_marca == this.produtos_cadastrados_filtrados[i].marca){
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
          }
        }

        this.confirmarQtdProdutoPromocao(this.produtos_filtrados.length);
      },

      async buscarQuantidadeTotalProdutosEmPromocao(){       
        this.confirmarQtdProdutoPromocao(this.qtd_total_produtos_promocao);  
      },

      confirmarQtdProdutoPromocao(qtd_produtos){
        this.$emit(
          'quantidade_produto_promocao', 
          {quant_produto: qtd_produtos, nome_empresa: this.nome_empresa}
        );
      },
   
      filtrarProdutos() {
        this.produtos_filtrados = [];
        this.mudarPagina(0);

        if (this.filtro_produtos == '') {
          this.produtos_filtrados = this.produtos_cadastrados_filtrados;
          return;
        }

        this.filtro_produtos = this.filtro_produtos.toUpperCase().replace('.', '');
        for (let i = 0; i < this.produtos_cadastrados_filtrados.length; i++) {
          let produto_id = Biblioteca.numeros(
            Biblioteca.nPadrao(this.produtos_cadastrados_filtrados[i].produto_id)
          );

          let nome_produto = (
            this.produtos_cadastrados_filtrados[i]
            .nome_produto.replace('.', '')
            .toUpperCase()
          );

          if (nome_produto.indexOf(this.filtro_produtos) > -1) {
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
            continue;
          }
          
          if (produto_id.indexOf(this.filtro_produtos) > -1) {
            this.produtos_filtrados.push(this.produtos_cadastrados_filtrados[i]);
            continue;
          }
        }
      },
      
      async buscarUsuarioLogado() {
        if (!RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }

        let resposta =  await JSON.parse(JSON.stringify(store.state.usuario_logado));
        this.usuario_logado = resposta.empresa_logada_id;
      },

      async buscarProdutosEmPromocao() {
        this.processando_produtos = true;
        this.produtos_filtrados = [];
        this.produtos_cadastrados_filtrados = [];
        this.filtro_marca = '';
        this.filtro_produtos = '';        
        
        try {
          let retorno = await RProdutoBuscarProdutosEmPromocao.buscarProdutosEmPromocaoDashboard(
            this.axios,
            {empresa_id: this.empresa_selecionada_id}
          );
          
          if (retorno.houve_erro != 'N') {
            this.confirmarQtdProdutoPromocao(0);
            throw new Error(retorno.mensagem);
          }

          this.produtos_filtrados = [];
          this.produtos_cadastrados_filtrados = [];

          if (retorno.dados){
            this.produtos_cadastrados_filtrados = JSON.parse(JSON.stringify(retorno.dados));
            this.produtos_filtrados = JSON.parse(JSON.stringify(retorno.dados));
            await this.filtrarMarca();
          }
          
          this.processando = false;
          this.processando_produtos = false;
        } 
        catch (error) {
          this.processando = false;
          this.processando_produtos = false;
          Biblioteca.exclamar(error.message);
        }
      },

      nPadrao(numero, casas_decimais = 2) {
        let retorno = Biblioteca.nPadrao(numero, casas_decimais);
        return retorno
      },

      nPadraoReais(numero) {
        return Biblioteca.nPadraoReais(numero);
      },

      fData(data) {
        return Biblioteca.fData(data);
      },

      nPadraoPercentual(numero) {
        return Biblioteca.nPadraoPercentual(numero);
      },

      getDiasRestantes(dias) {
        if (dias == 1) {
          return '1 ' + ' dia restante';
        }
        else {
          return Biblioteca.nPadrao(dias, 0) + ' dias restantes';
        }
      },
    },

    async created() {
      this.processando = true;
      this.empresas_autorizadas = JSON.parse(JSON.stringify(await store.state.empresas_autorizadas))
      this.empresa_selecionada_id = await store.state.empresa_logada.empresa_id;
      await this.buscarUsuarioLogado();      
      await this.buscarProdutosEmPromocao();

      this.qtd_total_produtos_promocao = 0;
      if (this.produtos_cadastrados_filtrados){
        this.qtd_total_produtos_promocao = this.produtos_cadastrados_filtrados.length
      }
    },
    
    mounted() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'slow', 'swing');
    },
    
    computed: {
      marcas() {
        let produtos_lista_filtrada = this.produtos_cadastrados_filtrados;

        let marcas_filtradas = produtos_lista_filtrada.filter((thing, index, self) =>
          index === self.findIndex((marca) => (
            marca.marca === thing.marca
          ))
        )

        marcas_filtradas.sort((a, b) => {
          var textA = a.marca.toUpperCase();
          var textB = b.marca.toUpperCase();
          return (textA < textB) ? - 1 : (textA > textB) ? 1 : 0;
        })

        return marcas_filtradas
      },

      novosProdutosFiltrados() {
        let produtos_lista_filtrada = this.produtos_filtrados;
        
        if (this.filtro_marca) {
          produtos_lista_filtrada = produtos_lista_filtrada.filter(obj => {
            return obj.marca === this.filtro_marca
          })
        };
        
        this.totalResultados = produtos_lista_filtrada.length;
        this.totalDePaginas =  Math.ceil(this.totalResultados / 10);

        if(this.paginaAtual >= this.totalDePaginas) { 
          this.paginaAtual = this.totalDePaginas;
        };

        let index = this.paginaAtual * 10;
        return produtos_lista_filtrada.slice(index, index + 10);
      }
    }
  }
</script>

<style scoped>
  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

.link {
  color: #af1a1a;
  text-decoration: underline;
  cursor: pointer;
  padding-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ProdutosEmPromocao.vue